export default __webpack_public_path__ + "static/media/back-arrow-responsive.764da991.svg";